import { Link } from "react-router-dom";
import { Clock, Sparkles } from "lucide-react";

export default function TrialBanner({ user }) {
    if (!user || user.subscription_status === "active") return null;

    // Compute days left from trial_ends_at
    const trialEnd = user.trial_ends_at ? new Date(user.trial_ends_at) : null;
    if (!trialEnd) return null;
    const now = new Date();
    const msLeft = trialEnd.getTime() - now.getTime();
    if (msLeft <= 0) return null; // expired - handled by route guard

    const daysLeft = Math.ceil(msLeft / (1000 * 60 * 60 * 24));
    const isUrgent = daysLeft <= 1;

    return (
        <div
            className={`flex items-center justify-between gap-4 px-5 py-3 rounded-xl border mb-6 ${
                isUrgent
                    ? "bg-[#d90429]/8 border-[#d90429]/40"
                    : "bg-amber-brand/15 border-amber-brand"
            }`}
            data-testid="trial-banner"
        >
            <div className="flex items-center gap-3 min-w-0">
                <div
                    className={`w-9 h-9 rounded-lg flex-shrink-0 flex items-center justify-center ${
                        isUrgent ? "bg-[#d90429] text-white" : "bg-amber-brand text-navy"
                    }`}
                >
                    <Clock size={18} />
                </div>
                <div className="min-w-0">
                    <div className="font-semibold text-navy text-sm">
                        Periodo di prova:{" "}
                        <span className={isUrgent ? "text-[#d90429]" : "text-navy"}>
                            {daysLeft === 1 ? "ultimo giorno" : `${daysLeft} giorni rimasti`}
                        </span>
                    </div>
                    <div className="text-xs text-sf-secondary truncate">
                        Termina il{" "}
                        {trialEnd.toLocaleDateString("it-IT", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        })}
                        .{" "}
                        {!user.has_billing_info
                            ? "Inserisci i dati di fatturazione per poter attivare l'abbonamento."
                            : "Scegli un piano per non interrompere il servizio."}
                    </div>
                </div>
            </div>
            <Link
                to={user.has_billing_info ? "/pricing" : "/billing/info"}
                state={user.has_billing_info ? undefined : { next: "/pricing" }}
                className={`flex-shrink-0 text-xs font-bold uppercase tracking-widest px-3 py-2 rounded-md lift ${
                    isUrgent
                        ? "bg-[#d90429] text-white hover:bg-[#a90020]"
                        : "bg-navy text-white hover:bg-navy/90"
                }`}
                data-testid="trial-banner-cta"
            >
                <Sparkles size={12} className="inline mr-1" />
                {user.has_billing_info ? "Attiva piano" : "Compila dati"}
            </Link>
        </div>
    );
}
